function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Arrow Icon");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "(C)-Candidate-Card-Menu-",
  transform: "translate(-20.000000, -122.000000)",
  fill: "#002645"
}, React.createElement("g", {
  id: "Arrow-Icon",
  transform: "translate(20.000000, 121.000000)"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(12.153968, 11.049587) rotate(-315.000000) translate(-12.153968, -11.049587) translate(2.291899, 1.369587)"
}, React.createElement("polygon", {
  id: "Path",
  points: "16.137931 5.70704761 2.73470917 18.8628254 0.198877951 16.3738095 13.2944519 3.52 5.37931034 3.52 5.37931034 8.23788998e-13 16.137931 8.25728838e-13 19.7241379 2.25597319e-13 19.7241379 14.08 16.137931 14.08"
})))));

var SvgMove = function SvgMove(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "26px",
    height: "21px",
    viewBox: "0 0 26 21",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/move.2ac8a2b5.svg";
export { ForwardRef as ReactComponent };